module.exports = __webpack_public_path__ + "img/icon_status_green_big.eb9d3470.svg";